module.exports = __webpack_public_path__ + "static/media/hide-icon.f983ba23.svg";